module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "imagel"
  }, [_c('a', {
    attrs: {
      "id": "ch007"
    }
  }), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0022-01.jpg",
      "width": "450px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“COMMANDER WILLIAM T. RIKER (played by Jonathan Frakes): Number One (whom the U.S. Navy would call the ‘Executive Officer’) is in his early thirties, considered by Starfleet to be a top quality captain-in-training. His principal responsibilities are:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“1. to constantly provide the Captain with a top condition vessel and crew, and,")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“2. to command away missions.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Like all First Officers, Riker feels highly possessive about the "), _c('em', [_vm._v("Enterprise")]), _vm._v("—considers it "), _c('em', [_vm._v("his")]), _vm._v(" ship, quite understandably since he is the one responsible for keeping the vessel polished and efficient. (From time immemorial First Officers have considered the ship captain as one who merely "), _c('em', [_vm._v("uses")]), _vm._v(" the vessel.) This creates no friction between Picard and Riker since, after all, Picard was the same kind of proud First Officer before becoming a Captain….")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“One of Riker’s special charms (shared also by the actor) is the ‘twinkle’ in his eye which suggests a very special sense of humor.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Riker is called ‘Number One’ by the Captain. Only rarely is he called that by an "), _c('em', [_vm._v("Enterprise")]), _vm._v(" crewmember, and never by anyone not part of the "), _c('em', [_vm._v("Enterprise")]), _vm._v(". Socially, his friends call him "), _c('em', [_vm._v("Will")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Riker was born in Valdez, Alaska, and there is a strong outdoors pioneer quality in his personality…. Like the legendary 23rd century Kirk (when in his early thirties), our Number One is very strong and agile and has a tendency toward ‘derring-do.’ Also like Captain Kirk, Riker has a healthy sex drive.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("—from the "), _c('em', [_vm._v("Star Trek: The Next Generation")]), _vm._v(" writers’/directors’ guide ’88–89, second-season revision")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0023-01.jpg",
      "width": "450px"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0fc7063f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch007.vue
// module id = 93
// module chunks = 0